import React, { useCallback, useEffect } from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import Autoplay from 'embla-carousel-autoplay';
import { Star, Quote, ChevronLeft, ChevronRight } from 'lucide-react';

const TestimonialsCarousel = ({ testimonials }) => {
  const [emblaRef, emblaApi] = useEmblaCarousel(
    { loop: true, align: 'center' },
    [Autoplay({ delay: 5000, stopOnInteraction: false })]
  );

  const scrollPrev = useCallback(() => {
    if (emblaApi) emblaApi.scrollPrev();
  }, [emblaApi]);

  const scrollNext = useCallback(() => {
    if (emblaApi) emblaApi.scrollNext();
  }, [emblaApi]);

  return (
    <div className="relative">
      {/* Carousel */}
      <div className="overflow-hidden" ref={emblaRef}>
        <div className="flex">
          {testimonials.map((testimonial) => (
            <div key={testimonial.id} className="flex-[0_0_100%] min-w-0 md:flex-[0_0_50%] lg:flex-[0_0_33.333%] px-4">
              <div className="group p-8 rounded-2xl bg-gradient-to-br from-rose-900/10 to-transparent border border-rose-900/20 hover:border-rose-200/40 transition-all duration-300 h-full">
                <div className="flex items-center justify-between mb-6">
                  <Quote className="w-10 h-10 text-rose-200/30" />
                  <div className="flex">
                    {[...Array(5)].map((_, i) => (
                      <Star key={`star-${testimonial.id}-${i}`} className="w-4 h-4 text-rose-200 fill-current" />
                    ))}
                  </div>
                </div>
                
                <p className="text-gray-300 leading-relaxed mb-6 italic min-h-[120px]">
                  &ldquo;{testimonial.text}&rdquo;
                </p>
                
                <div className="border-t border-rose-900/20 pt-4">
                  <p className="text-rose-200 font-medium">{testimonial.author}</p>
                  <p className="text-gray-500 text-sm">{testimonial.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Navigation Buttons */}
      <button
        onClick={scrollPrev}
        className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 z-10 p-3 rounded-full bg-rose-200/10 border border-rose-200/30 text-rose-200 hover:bg-rose-200/20 transition-all duration-300 backdrop-blur-sm"
        aria-label="Avis précédent"
      >
        <ChevronLeft className="w-6 h-6" />
      </button>
      
      <button
        onClick={scrollNext}
        className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 z-10 p-3 rounded-full bg-rose-200/10 border border-rose-200/30 text-rose-200 hover:bg-rose-200/20 transition-all duration-300 backdrop-blur-sm"
        aria-label="Avis suivant"
      >
        <ChevronRight className="w-6 h-6" />
      </button>
    </div>
  );
};

export default TestimonialsCarousel;
